import axios from 'axios';
import config from '../config';

// const isProd =
//   process.env.NODE_ENV === 'production' &&
//   document.location.origin !== 'https://services3-dev.hdb.gov.sg' &&
//   document.location.origin !== 'https://services3-stg.hdb.gov.sg';
const isStg = document.location.origin === 'https://services3-stg.hdb.gov.sg';
const isDev = document.location.origin === 'https://services3-dev.hdb.gov.sg';
const isNonProd = isDev || isStg;

const safeCompare = (str1: string, str2: string) => {
  let mismatch = false;
  if (str1.length !== str2.length) {
    mismatch = true;
  }

  for (let i = 0; i < str1.length; i++) {
    if (str1.charCodeAt(i) !== str2.charCodeAt(i)) {
      mismatch = true;
    }
  }

  return !mismatch;
}


export let WarningAlertAxios = () => {
  let headers: any;
  headers = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  };

  return axios.create({
    headers: headers,
    withCredentials: true
  });
}

export let PolymerAxios = (
  uinfin: string = '',
  token: string = '',
  uen: string = '',
  contentType: string = 'application/json',
  fileSize: number = 0,
  fileName: string = '',
  isPublic: boolean = false
) => {
  let headers: any;
  if (isPublic) {
    headers = {
      'X-Content-Type-Options': 'nosniff',
      'Content-Type': contentType,
    };
  } else {
    headers = {
      'X-Content-Type-Options': 'nosniff',
      'Content-Type': contentType,
      Authorization: `Bearer ${token}`,
    };
  }

  // Uinfin will be injected only for DEV and STG env
  if (isNonProd && uinfin.length > 0) {
    headers.uinfin = uinfin;
  }

  // UEN is not sensitive can be added to all environments
  if (uen.length > 0) {
    headers.uen = uen;
  }

  if (contentType === 'multipart/form-data') {
    headers['Content-Type'] = 'application/json'; ///NEW : Added for base 64
    headers['File-Length'] = fileSize;
    headers['Content-Disposition'] = `attachment; filename="${fileName}"`;
  }
  return axios.create({
    headers: headers,
  });
};
